<template>
  <div class="box" @scroll="handleScroll($event)">
    <Header ref="headerNav" />
    <div class="content">
      <div class="headerbg">
        <span>市场营销综合实训系统</span>
        <b>MARKETING COMPREHENSIVE TRAINING SYSTEM</b>
      </div>
      <div class="mainbody">
        <div class="setionbox">
          <p>
            《市场营销综合实训系统》集成了四大板块，循序渐进的涵盖市场营销的管理和技能锻炼，形成完整的体系。
主要分为了解自身特点、提升必要能力、实践学习体验和熟悉网络营销四大板块。
          </p>
        </div>
        <div class="setionbox">
          <div class="setiontop">
            <div class="left">
              <p>市场营销综合实训系统</p>
              <div class="line"></div>
              <div class="text">
                <p><img style="width:16px;" src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/MarketingComprehensiveTrainingSystem/fanngkuai.png" alt=""> 了解自身特点</p>
                <p><img style="width:16px;" src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/MarketingComprehensiveTrainingSystem/fanngkuai.png" alt=""> 提升必要能力</p>
                <p><img style="width:16px;" src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/MarketingComprehensiveTrainingSystem/fanngkuai.png" alt=""> 实践学习体验</p>
                <p><img style="width:16px;" src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/MarketingComprehensiveTrainingSystem/fanngkuai.png" alt=""> 熟悉网络营销</p>
              </div>
            </div>
            <div class="right">
              <img
                style="width: 547px"
                src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/MarketingComprehensiveTrainingSystem/img1.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <div class="setionbox">
          <div class="setion">
            <div>
              <img
                class="transparent-line"
                style="width: 46px"
                src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/InternationalBusinessSimulationTeachingPlatform/line.png"
                alt=""
              />
              <div class="imgbox">
                <img
                  style="width: 70px"
                  src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/MarketingComprehensiveTrainingSystem/img2.png"
                  alt=""
                />
              </div>
              <div class="underbox">
                <span>了解自身特点</span>
                <p>职业性格、职业取向、心理稳定</p>
                <p>创新能力、管理能力、营销能力</p>
                <p>综合职业测评</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
              </div>
            </div>
            <div>
               <img
                class="transparent-line"
                style="width: 46px"
                src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/InternationalBusinessSimulationTeachingPlatform/line.png"
                alt=""
              />
              <div class="imgbox">
                <img
                  style="width: 70px"
                  src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/MarketingComprehensiveTrainingSystem/img3.png"
                  alt=""
                />
              </div>
              <div class="underbox">
                <span>提升必要能力</span>
                <p>思维训练</p>
                <p>典型案例</p>
                <p>营销能力塑造</p>
               <p>&nbsp;</p>
               <p>&nbsp;</p>
              </div>
            </div>
            <div>
               <img
                class="transparent-line"
                style="width: 46px"
                src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/InternationalBusinessSimulationTeachingPlatform/line.png"
                alt=""
              />
              <div class="imgbox">
                <img
                  style="width: 70px"
                  src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/MarketingComprehensiveTrainingSystem/img4.png"
                  alt=""
                />
              </div>
              <div class="underbox">
                <span>实践学习体验</span>
                <p>营销管理过程</p>
                <p>模拟竞争</p>
                <p>营销模式实施</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
              </div>
            </div>
            <div>
               <img
                class="transparent-line"
                style="width: 46px"
                src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/InternationalBusinessSimulationTeachingPlatform/line.png"
                alt=""
              />
              <div class="imgbox">
                <img
                  style="width: 66px"
                 src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/MarketingComprehensiveTrainingSystem/img5.png"
                  alt=""
                />
              </div>
              <div class="underbox">
                <span>熟悉网络营销</span>
                <p>网络营销技能</p>
                <p>网站营销训练</p>
                <p>网络营销训练</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
              </div>
            </div>

            <!--  -->
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  name: 'MarketingComprehensiveTrainingSystem',
  methods:{
     handleScroll (e) {
      if(e.srcElement.scrollTop>2){
        this.$refs.headerNav.showHeadBj()
      }else {
        this.$refs.headerNav.hideHeadBj()
      }
      //滚动事件
    },
  }
}
</script>

<style lang="scss" scoped>
.setionbox:nth-child(odd) {
  background: #f8f8f8;
  .left {
    padding-left: 70px;
  }
}
.setiontop {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 1200px;
  padding-top: 80px;
  padding-bottom: 80px;

  .left {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: start;
    p {
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #333333;
    }
    .line {
      margin-top: 20px;
      width: 120px;
      height: 4px;
      background: #f39a21;
    }
    .text > p {
      width: 200px;
      margin-top: 35px;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #1c43bd;
    }
  }
  .right {
    flex: 1;
  }
}
.box {
  width: 100%;
  height: 100%;
  overflow: auto;
  // position: relative;
}
.headerbg {
  width: 100%;
  height: 580px;
  background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/MarketingComprehensiveTrainingSystem/headerbgi.png");
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  span {
    font-size: 42px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
  b {
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #006cda;
  }
}
.setionbox {
  width: 100%;
  // background-color: red;
  .setion {
    margin: 0 auto;
    width: 1200px;
    padding-top: 80px;
    padding-bottom: 80px;
    // background-color: #f5ff;
    display: flex;
    justify-content: space-around;
    align-items: center;

    div {
      width: 270px;
      background-color: #ffffff;
      // border: 1px solid #000;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      height: 418px;
      position: relative;
      .transparent-line {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 1;
      }

      .imgbox {
        flex: 1;
      }
      .underbox {
        flex: 1;
      }

      span {
        margin-top: 30px;
        margin-bottom: 29px;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #1c43bd;
      }
      p {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;
      }
    }
  }
}
.mainbody > .setionbox > p {
  padding-top: 30px;
  padding-bottom: 30px;
  width: 1080px;
  margin: 0 auto;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  background: #f8f8f8;
  text-align: center;
  line-height: 1.8;
}
</style>




// WEBPACK FOOTER //
// src/pages/MarketingComprehensiveTrainingSystem.vue